import palette from "./palette";
import shape from "./shape";
import shadows from "./shadows";
import typeset from "./typeset";

const CMS2 = {
    palette: palette,
    shadows: shadows,
    shape: shape,
    typography: typeset
}
export default CMS2